/**
 * Formatiert einen ISO-Zeitstempel im de-DE-Format `TT.MM.JJJJ, HH:MM:SS`.
 *
 * @param value ISO-8601-String, `null`/`undefined`/leer erlaubt.
 * @returns Formatiertes Datum, oder `'–'` wenn kein Wert vorliegt, oder der
 *   Rohwert, wenn er sich nicht parsen lässt.
 */
export function formatDateTime(value?: string | null): string {
  if (!value) return '–';
  try {
    return new Date(value).toLocaleString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  } catch {
    return value;
  }
}

/**
 * Kürzt eine UUID für die Tabellen-Darstellung auf `Präfix…Suffix`
 * (erste 8 + letzte 4 Zeichen); der volle Wert gehört in `title`/Modal.
 * Werte, die durch Kürzung nicht kürzer würden, bleiben unverändert.
 */
export function shortenUuid(value: string): string {
  if (value.length <= 13) return value;
  return `${value.slice(0, 8)}…${value.slice(-4)}`;
}
